<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-flex px-4 mt-4>
                    <v-form ref="translated_article">
                        <v-layout row :wrap="$bp.smallScreen" align-baseline class="mt-3">
                            <v-flex pt-0>
                                <v-layout>
                                    <v-flex xs8 mr-3>
                                        <bc-autocomplete
                                            v-model="edit_mod"
                                            :label="$t('lang.filter_modules')"
                                            :items="modules"
                                            item-text="display_name"
                                            return-object
                                            class="mt-0"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-autocomplete
                                            v-model="language"
                                            :label="$t('lang.select_a_language_to_edit')"
                                            :items="languages"
                                            item-text="language"
                                            item-value="iso"
                                            :rules="ifValid('english_article.language')"
                                            class="mt-0"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <div
                                    v-if="!edit_mod || !language"
                                    style="width: 100%; height: 50vh; display: flex; justify-content: center; align-items: center;"
                                    class="grey--text"
                                >
                                    {{!edit_mod || !language ? $t('lang.select_mod_lang') : null}}
                                </div>
                                <div
                                    v-if="edit_mod && language && current_articles.length == 0"
                                    style="width: 100%; height: 50vh; display: flex; justify-content: center; align-items: center;"
                                    class="grey--text"
                                >
                                    {{$t('lang.no_articles_found') + edit_mod.display_name}}
                                </div>
                                <vue-perfect-scrollbar v-if="edit_mod && language && current_articles.length > 0" :style="edit_mod && current_articles.length > 0 ? null : 'height: 600px'" :settings="settings" class="pa-2">
                                    <v-flex v-for="(article, index) in current_articles" :key="index" class="mb-3">
                                        <v-layout :row="!$bp.smallScreen" :column="$bp.smallScreen">
                                            <v-flex xs6 :mr-3="!$bp.smallScreen">
                                                <v-card class="px-3 pb-3" style="border-radius: 10px">
                                                    <v-flex class="my-3">
                                                        <v-layout row>
                                                            <v-flex align-center>
                                                                <h4 class="mb-0">{{article.title}}</h4>
                                                            </v-flex>
                                                            <v-chip class="ml-auto">{{article.display_name}}</v-chip>
                                                        </v-layout>
                                                    </v-flex>
                                                    <div>
                                                        <v-divider></v-divider>
                                                        <div class="mt-3"> {{ article.article }} </div>
                                                    </div>
                                                </v-card>
                                            </v-flex>
                                            <v-flex xs6 :mt-3="$bp.smallScreen">
                                                <v-card class="px-3 pb-3" style="border-radius: 10px">
                                                    <v-form :ref="`checkInputs${index}`" lazy-validation :class="index != current_article_id && current_article_id != null ? 'ignore-form' : ''">
                                                        <v-text-field
                                                            v-model="new_article[index].title"
                                                            :label="$t('lang.update_title')"
                                                            @focus="current_article_id = index"
                                                            :disabled="index != current_article_id && current_article_id != null ? true : false"
                                                            :counter="showCounter(new_article[index].title, 'english_article.title')"
                                                            :rules="index == current_article_id ? ifValid('english_article.title') : []"
                                                        ></v-text-field>
                                                        <v-textarea
                                                            v-model="new_article[index].article"
                                                            :label="$t('lang.update_article')"
                                                            rows='1'
                                                            auto-grow
                                                            @focus="current_article_id = index"
                                                            :disabled="index != current_article_id && current_article_id != null ? true : false"
                                                            :rules="index == current_article_id ? ifValid('english_article.article') : []"
                                                        ></v-textarea>
                                                    </v-form>
                                                    <v-btn color="success" :disabled="index == current_article_id ? false : true" class="ml-0 w-100" @mouseup.left="updateArticles(index, article)">{{$t('lang.save_article')}}</v-btn>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </vue-perfect-scrollbar>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-flex>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    data() {
        return {
            current_article_id: null,
            language: null,
            languages: [],
            edit_mod: null,
            modules: [],
            disable: false,
            english_article: [],
            new_article: [],
            current_articles: [],
            settings: {
                maxScrollbarLength: 160,
            }
        };
    },
    watch: {
        language(){
            if(this.edit_mod && this.language){
                this.getArticles(this.edit_mod);
                this.current_article_id = null;
            }
         },
        edit_mod(){
            if(this.edit_mod && this.language){
                this.getArticles(this.edit_mod);
                this.current_article_id = null;
            }
        }
    },
    computed: {
        ...mapState({
            rules_english_article: state => state.validation.rules_english_article,
        }),

    },
    mounted() {
        this.getModules();
        this.getLanguages();
    },
    methods:{
        getModules() {
            this.$store.dispatch(
                "fetchModules",
                {
                    url: 'modules',
                    method: 'get',
                    stateProperty: 'modules',
                    commit: true
                }
            ).then((data) => {
                this.modules = data.modules;
            })
        },
		getArticles(mod){
            this.startLoader();
			this.$store.dispatch(
				"fetchHelp",
				{
					url: 'help?module=' + mod.display_name + '&language=en&not_translated=' + this.language,
					method: 'get',
					stateProperty: 'articles',
				}
			).then((data) => {
                //only select the module they want
                this.current_articles = data.help_articles;
                this.new_article = [];
                this.current_articles.forEach(article => {
                    this.new_article.push({
                        module_id: mod.module_id,
                        language: '',
                        article: '',
                        title: '',
                        status: 9,
                        disable: false,
                    })

                })
                this.finishLoader();
			})
        },
        updateArticles(id, article) {
            this.$store.commit('validationOn');
            this.$nextTick(() => {
                if (this.validateForm('translated_article')){
                    let body = {help_articles: []}

                    let updated_article = this.new_article.filter(article => {
                        return article.article.length > 0;
                    })

                    this.new_article.forEach(article => {
                        return article.language = this.language
                    })

                    delete updated_article[0].disable

                    let new_article_to_send = updated_article[0]

                    let english_article = {
                        module_id: article.module_id,
                        language: article.language,
                        article: article.article,
                        title: article.title,
                        help_id: article.help_id
                    }

                    body.help_articles.push(english_article)
                    body.help_articles.push(new_article_to_send)

                    this.startLoader();
                    this.$store.dispatch(
                        "fetchHelp",
                        {
                            url: 'help',
                            method: 'patch',
                            body
                        }
                    ).then(() => {
                        this.new_article.forEach(article => {
                            article.disable = false;
                        })
                        this.current_articles = this.current_articles.filter((article, index) => {
                            return id != index;
                        })
                        this.new_article = this.new_article.filter((article, index) => {
                            return id != index;
                        })
                        this.$store.commit('validationOff');
                        this.finishLoader();
                    })
                }
            })
        },
		getLanguages(){
            this.startLoader();
			this.$store.dispatch(
				"fetchLanguages",
				{
					url: 'languages',
					method: 'get',
					stateProperty: 'all_languages',
				}
			).then((data) => {
                this.languages = data.languages;
                this.finishLoader();
			})
        },
  }
};
</script>